<template>
  <div class="flex flex-col flex-nowrap">
    <div
      class="grid-rows-opcoes items-center relative"
      :class="{
        active: respostas?.[alternativa.id],
        'opacity-75 pointer-events-none': isDisabledResposta,
      }"
      :style="{
        '--color':
          respostas?.[alternativa.id]?.respostas?.at(-1)?.cor,
      }"
    >
      <template
        v-for="(itemopcao, index) in alternativa.itemopcao_set"
        :key="itemopcao.id"
      >
        <div v-if="!tipoOpcao.tradicional" class="px-20">
          <h3 class="text-headline-3 text-neutral-70">
            {{ itemopcao.opcao_titulo_readonly }}
          </h3>
        </div>
        <ItemOptButton
          v-if="tipoOpcao.tradicional"
          :color-active="corActive(alternativa, itemopcao)"
          :label="itemopcao.opcao_titulo_readonly"
          :itemopcao
          @click:opt="
            $emit('click:opt', { itemopcao, alternativa, index })
          "
        />
        <ItemOptCheckbox
          v-else-if="tipoOpcao.checkbox"
          :color-active="corActive(alternativa, itemopcao)"
          :label="itemopcao.opcao_titulo_readonly"
          :itemopcao
          @click:opt="$emit('click:opt', { itemopcao, alternativa })"
        />
        <ItemOptSimNao
          v-else-if="tipoOpcao.sim_nao_livre"
          :color-active="corActive(alternativa, itemopcao)"
          :label="itemopcao.opcao_titulo_readonly"
          :itemopcao
          @update:opt="
            ({ value, livre }) =>
              $emit('update:opt', {
                itemopcao,
                alternativa,
                value,
                livre,
              })
          "
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import ItemOptButton from 'components/PagePergunta/ItemOptButton.vue'
import ItemOptCheckbox from 'components/PagePergunta/ItemOptCheckbox.vue'
import ItemOptSimNao from 'components/PagePergunta/ItemOptSimNao.vue'
import usePerguntas from 'composables/usePerguntas'

const { respostas } = defineProps({
  alternativa: Object,
  respostas: Object,
  tipoOpcao: Object,
})

const { isDisabledResposta } = usePerguntas()

const emit = defineEmits(['click:opt', 'update:opt'])

const corActive = (alternativa, itemopcao) => {
  const res = respostas?.[alternativa.id]?.respostas?.find(
    (r) => r.opcao === itemopcao.opcao
  )
  return res ? res.cor : null
}
</script>

<style lang="scss"></style>
